export default {
  list: [
    {
      text: '日常自檢',
      value: 'checklist',
    },
    {
      text: '變動管理',
      value: 'change',
    },
    {
      text: '證照管理',
      value: 'license',
    },
    {
      text: '教育訓練',
      value: 'training',
    },
    {
      text: '風險事件',
      value: 'event',
    },
    {
      text: '稽核管理',
      value: 'audit',
    },
    {
      text: '承攬商管理',
      value: 'contractor',
    },
    {
      text: '進廠',
      value: 'contractorEnter',
    },
    {
      text: '集團概況',
      value: 'organization-dashboard-read',
    },
    {
      text: '各廠概況',
      value: 'factory-dashboard-read',
    },
    {
      text: '內規',
      value: 'guideline',
    },
    {
      text: '法規',
      value: 'act',
    },
    {
      text: '代理人',
      value: 'agent',
    },
    {
      text: '警示',
      value: 'alert',
    },
    {
      text: '看板',
      value: 'board',
    },
    {
      text: '設定',
      value: 'setting',
    },
    {
      text: '快報',
      value: 'broadcast',
    },
    {
      text: '檔案庫',
      value: 'file',
    },
    {
      text: '通知',
      value: 'notification',
    },
    {
      text: 'QRcode',
      value: 'qrcode',
    },
    {
      text: '權限',
      value: 'scope',
    },
    {
      text: 'sos',
      value: 'sos',
    },
    {
      text: '系統',
      value: 'system',
    },
    {
      text: '任務',
      value: 'task',
    },
    {
      text: '新訊',
      value: 'announcement',
    },
    {
      text: '數量統計',
      value: 'factory-statistic',
    },
    {
      text: '議事',
      value: 'meeting',
    },
    {
      text: '操作記錄',
      value: 'log',
    },
  ],
};
